export default creditCardNumber =>
  !!creditCardNumber && typeof creditCardNumber === 'string' ? creditCardNumber.slice(-4) : '';
